// extracted by mini-css-extract-plugin
export default {"messageBlock":"messageBlock__1ATRk"};